<!--
HACCP情報CSV出力画面
URL：/umilog
-->

<template>
  <div>
    <div class="ml-2 mt-12 text-h5">{{ title }}</div>
    <div class="ml-4 blue-grey--text">赤印のある項目は必須入力です</div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <v-container style="max-width: 800px">
      <v-row>
        <v-col cols="12" align="right">
          <v-btn color="primary" class="ma-2" width="200" @click="getNewData"
            >最新データ取得</v-btn
          >
        </v-col>
      </v-row>
      <v-row style="height: 30px"> </v-row>
      <v-row
        v-for="input in inputs"
        :key="input.key"
        no-gutters
        dense
        class="mb-2"
      >
        <v-col cols="3">
          <v-subheader class="title mr-2" style="height: 100%"
            >{{ input.title
            }}<v-icon class="ml-1 mb-3 red--text caption" v-if="input.required"
              >mdi-asterisk</v-icon
            ></v-subheader
          ></v-col
        >
        <v-col
          cols="8"
          style="
            margin-top: 6px;
            margin-bottom: -6px;
            margin-left: 12px;
            width: 280px;
            height: 70px;
          "
          v-if="input.key == 'outputBuoy'"
        >
          <v-select
            class="text-h7"
            outlined
            color="#0ddbc7"
            placeholder="出力対象ブイを選択してください"
            v-model="opBuoy"
            :items="buoyList"
            no-data-text="データがありません"
          ></v-select>
        </v-col>
        <v-col cols="4" v-if="input.key == 'outputDate'">
          <custom-date-picker
            :dateSub="dateStart"
            :events="events"
            :defaultFocus="defaultFocus"
            @on-update-registration-date="selectStartDate"
          ></custom-date-picker>
        </v-col>

        <v-col
          cols="1"
          class="text-h5"
          style="
            text-align: center;
            font-size: 50px;
            margin-top: 24px;
            padding: 0px;
          "
          v-if="input.key == 'outputDate'"
        >
          ～
        </v-col>

        <v-col cols="4" v-if="input.key == 'outputDate'">
          <custom-date-picker
            :dateSub="dateEnd"
            :events="events"
            :defaultFocus="dateEnd"
            @on-update-registration-date="selectEndDate"
          ></custom-date-picker>
        </v-col>
      </v-row>
    </v-container>
    <v-container style="max-width: 800px">
      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn color="primary" class="ma-2" width="200" @click="download"
            >ダウンロード</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CustomDatePicker from "../../components/record-update/custom-date-picker.vue";
import Api from "@/logic/api/api.js";
import DateWrapper from "../../logic/common/date-wrapper";
import Alert from "../../components/common/alert.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import { required } from "vuelidate/lib/validators";
import valueMapper from "../../logic/common/value-mapper";
// import ValueConverer from "../../logic/common/value-converter";

export default {
  components: {
    "custom-date-picker": CustomDatePicker,
    alert: Alert,
  },
  data() {
    this.$nextTick(() => {
      this.loadData();
    });

    // 登録対象日_開始日(システム上の最古日を設定)
    this.dateStart = "2021-10-01";
    // 登録対象日_終了日
    var today = new Date();
    var nowYear = today.getFullYear();
    var nowMonth = ("00" + (today.getMonth() + 1)).slice(-2);
    var nowDay = ("00" + today.getDate()).slice(-2);
    this.dateEnd = nowYear + "-" + nowMonth + "-" + nowDay;
    // フォーカスの初期値
    const now = new DateWrapper(Date.now()).format;
    this.defaultFocus = now.systemDate;

    // 画面タイトル
    this.title = "うみログCSV出力";

    // 画面に表示する入力欄を定義する
    let inputs = [];
    // 出力対象ブイ
    inputs.push({
      key: "outputBuoy",
      title: "出力対象ブイ",
      required,
    });
    // 出力期間
    inputs.push({
      key: "outputDate",
      title: "出力期間",
    });
    // CSVファイル格納URL
    this.csvFileUrl = "";
    // API戻り値
    this.message = "";

    return {
      events: {},
      errors: [],
      inputs: inputs,
      buoyList: [],
      opBuoy: [],
    };
  },
  methods: {
    /**
     * うみログデバイス一覧を作成する
     */
    mkLocationList() {
      this.clearMessage();
      // let updateUrl = "";
      // let postData = null;
      
      // updateUrl = "/umilog/devices";
      // postData = {};
      // this.buoyList = [];
      // var deviceDataSub = { device_id: "", name: "" };
      // var deviceData = { item: "" };
      // var deviceListSub = [];

      // // うみログデバイス一覧情報を取得
      // Api.call(updateUrl, postData)
      //   .then((result) => {
      //     // デバイスが存在する場合はデバイス一覧を作成
      //     if (result.count > 0) {
      //       deviceDataSub = { device_id: "-2", name: "全出力" };
      //       deviceData = { item: deviceDataSub };
      //       deviceListSub[0] = deviceData;
      //       deviceDataSub = { device_id: "-1", name: "---------------------" };
      //       deviceData = { item: deviceDataSub };
      //       deviceListSub[1] = deviceData;
      //       var cnt = 2;
      //       for (const raw of result.devices) {
      //         deviceListSub[cnt++] = raw;
      //       }
      //       this.buoyList = ValueConverer.deviceForSelectbox(deviceListSub);
      //       // リストの先頭を選択
      //       this.opBuoy = "";
      //     }
      //     this.$store.commit("setWaiting", false);
      //   })
      //   .catch((error) => {
      //     this.$store.commit("setWaiting", false);
      //     const message = valueMapper
      //       .map({
      //         401: AlertBuilder.error("データの更新に失敗しました"),
      //       })
      //       .getOrElse(error.status, AlertBuilder.invalid());
      //     if (message.isInvalid) {
      //       Api.resolve(error);
      //     } else {
      //       this.showMessage(message);
      //     }
      //   });

      // デバイス情報格納リスト
      this.buoyList = [
        {
          text: "全出力",
          value: "-2",
        },
        {
          text: "---------------------",
          value: "-1",
        },
        {
          text: "玖波",
          value: 1,
        },
        {
          text: "大野",
          value: 2,
        },
        {
          text: "地御前",
          value: 3,
        },
        {
          text: "草津",
          value: 4,
        },
        {
          text: "坂",
          value: 5,
        },
        {
          text: "奈佐美",
          value: 6,
        },
        {
          text: "江田島湾",
          value: 7,
        },
        {
          text: "阿多田島",
          value: 8,
        },
        {
          text: "大黒神島",
          value: 9,
        },
        {
          text: "東江",
          value: 10,
        },
        {
          text: "大柿",
          value: 11,
        },
        {
          text: "音戸",
          value: 12,
        },
        {
          text: "倉橋",
          value: 13,
        },
        {
          text: "安浦",
          value: 14,
        },
        {
          text: "安芸津",
          value: 15,
        },
        {
          text: "御床",
          value: 16,
        },
      ];

    },
    /**
     * グループ情報を取得、画面に表示する
     */
    loadData() {
      this.$store.commit("setWaiting", true);
      this.$nextTick(() => {
        // うみログデバイス一覧を作成する
        this.mkLocationList();
      });
    },
    /**
     * 出力期間_開始日を画面から取得する
     */
    selectStartDate(selectDate) {
      // API指定用取得対象日_開始日
      this.dateStart = selectDate.replace(/-/g, "/");
    },
    /**
     * 出力期間_終了日を画面から取得する
     */
    selectEndDate(selectDate) {
      // API指定用取得対象日_終了日
      this.dateEnd = selectDate.replace(/-/g, "/");
    },
    /**
     * 計測データ取得用のデバイスIDを設定する(空指定時は全デバイスを取得)
     */

    buildLocationIdData(){
      var opBuoy = [];
      if (this.opBuoy > 0){
        opBuoy.push(this.opBuoy);
      }
      return{
        location_id: opBuoy,
      };  
    },
    /**
     * 最新データを取得する
     */
    getNewData() {
      let updateUrl = "";
      let postData = null;
      this.clearMessage();

      updateUrl = "/umilog/sensorlogs/update";
      postData = this.buildLocationIdData();

      this.$store.commit("setWaiting", true);

      // うみログ計測情報更新APIをコール
      Api.call(updateUrl, postData)
        .then((result) => {
          this.message = result.message;
          this.$store.commit("setWaiting", false);
          this.showMessage(AlertBuilder.info("データの取得が完了しました"));
          return;
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              400: AlertBuilder.error("データの更新に失敗しました"),
              401: AlertBuilder.invalid(),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    /**
     * 取得用送信データを画面から取得する
     */
    buildGetcsvData() {
      var opBuoy = [];
      // 全取得(-2)の場合チェック
      if (this.opBuoy != -2) {
        opBuoy.push(this.opBuoy);
      }
      return {
        location_id: opBuoy,
        record_date_start: this.dateStart.replace(/-/g, "/"),
        record_date_end: this.dateEnd.replace(/-/g, "/"),
      };
    },
    /**
     * 対象ファイルをダウンロードする
     */
    // async downloadCsv() {
    //   const response = await fetch(this.csvFileUrl);
    //   const blob = await response.blob();
    //   const newBlob = new Blob([blob]);
    //   const objUrl = window.URL.createObjectURL(newBlob);
    //   const link = document.createElement("a");
    //   link.href = objUrl;
    //   link.download = this.targetFileName;
    //   link.click();
    //   //   For Firefox it is necessary to delay revoking the ObjectURL.
    //   setTimeout(() => {
    //     window.URL.revokeObjectURL(objUrl);
    //   }, 250);
    // },
    downloadCsv() {
      const url = this.csvFileUrl;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.download = this.targetFileName;
      a.href = url;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
    /**
     * うみログ計測情報CSV取得
     */
    download() {
      // CSV取得
      let updateUrl = "";
      let postData = null;
      this.clearMessage();

      // 出力対象ブイの選択チェック
      if (this.opBuoy == "" || this.opBuoy == -1) {
        this.showMessage(AlertBuilder.error("出力対象ブイを選択してください"));
        return;
      }

      // 日付の相関チェック
      if (
        this.dateEnd.replace(/\//g, "-") < this.dateStart.replace(/\//g, "-")
      ) {
        this.showMessage(
          AlertBuilder.error(
            "出力期間の終了日は、開始日と同日か開始日よりも未来日を指定してください"
          )
        );
        return;
      }

      const startDate = new Date(this.dateStart);
      const endDate = new Date(this.dateEnd);
      const diffInMilliseconds = endDate - startDate;
      const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

      if (diffInDays > 366) {
        this.showMessage(AlertBuilder.error("出力期間は365日以内に設定してください"));
        return;
      }

      updateUrl = "/umilog/getcsv";
      postData = this.buildGetcsvData();

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
        .then((result) => {
          // ファイル名を取得
          this.targetFileName = result.file_name;
          // ファイルパスを取得
          this.csvFileUrl = result.file_url;
          // 対象ファイルをダウンロードする
          this.downloadCsv();
          this.$store.commit("setWaiting", false);
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              400: AlertBuilder.error("ダウンロードに失敗しました"),
              401: AlertBuilder.invalid(),
              403: AlertBuilder.error("権限がありません"),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.title {
  background-color: #999999;
  color: white;
}
</style>
